/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'CloudCheck': {
    width: 15,
    height: 11,
    viewBox: '0 0 15 11',
    data: '<path pid="0" d="M4.818 5.232a4.464 4.464 0 114.465 4.464H4.372a3.125 3.125 0 11.777-6.153" _stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M11.069 4.563L8.39 7.24l-1.34-1.34" _stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
